<template>
  <div class="employment-table--content cursor-pointer">
    <div class="j-week--labels-container">
      <div class="j-week--labels-overflow">
        <div class="day" v-for="(item, index) in dataComputed" :key="index">
          <div class="date text-center" :class="{'today': item.isToday === true}">
            {{datePhpToRus(item.date)}}, {{item.weekday}}
          </div>
          <div class="no-schedule" v-if="Object.keys(item.labels).length === 0">
            Нет расписания
          </div>
          <div class="staffs">
            <div class="staff" v-for="(staff, index) in item.labels" :key="index">
              <div class="name">{{getStaffName(index)}}</div>
              <div v-if="staff.result == 'error'" class="error">{{staff.text}}</div>
              <div v-if="staff.result == 'ok'" class="schedule">
                <div class="schedule-item" v-for="(sch, index) in staff.response" :key="index">
                  <div
                    @click="createEnroll(sch.time_from, staff.schedule.staff_id, datePhpToRus(item.date))"
                    class="item-free"
                    v-if="sch.type == 'free'"
                    v-bind:class="{ progress: sch.progress === true }"
                  >
                    <div>
                      <span>Окно  </span>
                      <span>{{minuteToTime(sch.time_from)}} - {{minuteToTime(sch.time_to)}}</span> <br>
                      <span class="time-window">({{getDiffTime(sch.time_from, sch.time_to)}})</span>
                    </div>
                    <div class="action">
                      <div class="new-enroll">
                        <div class="btn-tiny-circle btn-info">
                          <f-awesome icon="plus"></f-awesome>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-break" v-if="sch.type == 'break'">
                    Перерыв {{ minuteToTime(sch.time_from) }} -
                    {{ minuteToTime(sch.time_to) }}
                  </div>
                  <div
                    v-if="sch.type == 'enroll'"
                    class="item-enroll"
                    :class="{
                      'status-new': sch.confirm == 0,
                      'status-confirm': sch.confirm == 1,
                      'status-done': sch.confirm == 2,
                      'status-canceled': sch.confirm == 3,
                      'progress': sch.progress === true
                    }"
                  >
                    <div class="time" @click="updateEnroll(sch.id, sch.time_from, sch.staff_id, datePhpToRus(item.date))">
                      <span><b>{{minuteToTime(sch.time_from)}} - {{minuteToTime(sch.time_to)}}</b></span> <br>
                      <span class="time-window">({{getDiffTime(sch.time_from, sch.time_to)}})</span>
                    </div>
                    <div class="action" @click="slideEnroll(sch.id)">
                      <div v-if="sch.show_more === true" class="btn-sm-circle">
                        <f-awesome icon="caret-up"></f-awesome>
                      </div>
                      <div v-if="sch.show_more === false" class="btn-sm-circle">
                        <f-awesome icon="caret-down"></f-awesome>
                      </div>
                    </div>
                    <div
                      v-show="sch.show_more === true"
                      @click="updateEnroll(sch.id, sch.time_from, sch.staff_id, datePhpToRus(item.date))"
                      class="more"
                    >
                      <div v-if="+sch.is_group === 0" class="client_name">
                        <span v-if="sch.enrollClients[0].clientModification">
                          {{ sch.enrollClients[0].clientModification.name }}
                        </span>
                        <span v-if="!sch.enrollClients[0].clientModification">
                          {{ sch.enrollClients[0].clients.name }} {{ sch.enrollClients[0].clients.surname }}
                        </span>
                        <span v-if="sch.enrollClients[0].clients.sale">(скидка {{sch.enrollClients[0].clients.sale}}%) </span>
                        <span v-if="+sch.enrollClients[0].clients.is_unwanted === 1"><b>(нежелательный клиент!)</b></span>
                      </div>
                      <div v-if="+sch.is_group === 1" class="client_name">
                        <span class="text-bold">{{ calculateActiveGroupCount(sch.enrollClients) }}</span> клиента (-ов) в групповой записи
                      </div>
                      <div v-if="+sch.is_group === 0" class="client_number">{{  phoneNumberToMask(sch.enrollClients[0].clients.number) }}</div>
                      <div class="client_services">
                        <span v-for="service in sch.enrollPosition" :key="service.id"
                          >{{ service.service_name }}:
                        </span>
                      </div>
                      <div v-if="+sch.is_group === 0 && sch.enrollClients && sch.enrollClients[0].comment && +sch.is_group === 0" class="client_comment mrg-t-5">
                        Комментарий клиента: {{sch.enrollClients[0].comment?sch.enrollClients[0].comment:'-'}}
                      </div>
                      <div v-if="sch.comments && sch.comments.comment_company" class="company_comment mrg-t-5">
                        Ваш комментарий: {{sch.comments?sch.comments.comment_company:'-'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <popup
      :closeButton="editEnrollPopup.closeButton"
      :show="editEnrollPopup.show"
      :size="editEnrollPopup.size"
      :backgroundColor="editEnrollPopup.backgroundColor"
      @closePopup="closeEditEnrollPopup"
    >
      <div slot="header">
        {{ editEnrollPopup.header }}
        <hints :type="'text'" :title="'Скидка клиента'">
          <div slot="text">
            Скидка будет автоматически применяться к стоимости каждой позиции.<br><br>
            <span class="text-orange">Внимание!</span> Если, создавая запись, вы сами подкорректировали стоимость
            какой-либо услуги, то к этим позициям скидка применяться не будет<br><br>
            Скидка применяется только в том случае, если на момент создания или редактирования записи стоимость
            позиции соответствует полной стоимости
          </div>
        </hints>
      </div>
      <div slot="body">
        <fast-new
          :show="editEnrollPopup.show"
          :staffId="selectedStaffId"
          :default-date="fastNewDefaultDate"
          :want-time="wantTime"
          :loadEnrollId="selectedEnrollId"
          :mode="fastNewMode"
          @update="updateData"
          @updateLoadEnroll="updateLoadEnroll"
          @updateWantTime="updateWantTime"
          @closeAndUpdate="closeAndUpdateFast"
          @close="closeFast"
        ></fast-new>
      </div>
    </popup>


  </div>
</template>

<script>

import Formatter from "../../libraries/Formatter";
import Popup from '../../Popup.vue';
import Hints from '../../Hints.vue';
import FastNew from './fast_new/FastNew.vue';

const formatter = new Formatter();

export default {
  name: "EnrollLabelsWeek",
  components: {Popup, Hints, FastNew},
  data() {
    return {
      nowDate: new Date(),
      weekdayName: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
      weekdayNumber: [6, 0, 1, 2, 3, 4, 5],
      dateFrom: null,
      dateTo: null,
      calendar: [],
      showLabels: false,
      editEnrollPopup: {
        show: false,
        closeButton: 'Закрыть',
        size: "lg",
        header: "",
        backgroundColor: 'wgray'
      },
      fastNewDefaultDate: '1.1.1970',
      wantTime: 0,
      selectedEnrollId: null,
      fastNewMode: "new",
      selectedStaffId: 0,
    };
  },
  props: {
    data: Array,
    show: Boolean,
    staff: Array
  },
  watch: {

  },
  computed: {
    dataComputed(){
      return this.data;
    },
    weekString() {
      let result = "";
      if (this.dateFrom) {
        let dateFrom = formatter.phpDateToJSObject(this.dateFrom);
        let dateTo = formatter.phpDateToJSObject(this.dateTo);
        let monthFrom = dateFrom.getMonth() + 1;
        let monthTo = dateTo.getMonth() + 1;
        result = `${dateFrom.getDate()}.${
          monthFrom < 10 ? "0" + monthFrom : monthFrom
        } - ${dateTo.getDate()}.${monthTo < 10 ? "0" + monthTo : monthTo}`;
      }
      return result;
    },
  },
  methods: {
    calculateActiveGroupCount(data){
      let result = 0;
      for(let key in data){
        if(+data[key].is_canceled === 0){
            if(data[key].clients){
              result++;
            }
          }
      }
      return result;
    },
    phoneNumberToMask(number){
      return formatter.phoneNumberToMask(number);
    },
    slideEnroll(id) {
      this.$emit('slideEnroll', id);
    },
    createEnroll(wantTime, staffId, date) {
      this.fastNewMode = "new";
      this.selectedEnrollId = 0; // Сбросим
      this.editEnrollPopup.show = true;
      this.wantTime = wantTime;
      this.editEnrollPopup.header = "Добавление записи";
      this.selectedStaffId = +staffId;
      this.fastNewDefaultDate = date;
    },
    updateEnroll(id, wantTime, staffId, date) {
      this.fastNewMode = "edit";
      this.editEnrollPopup.show = true;
      this.selectedEnrollId = +id;
      this.wantTime = wantTime;
      this.editEnrollPopup.header = "Изменение записи";
      this.selectedStaffId = +staffId;
      this.fastNewDefaultDate = date;
    },
    closeFast() {
      this.closeEditEnrollPopup();
    },
    closeAndUpdateFast() {
      this.closeEditEnrollPopup();
      this.updateData();
    },
    updateLoadEnroll(val) {
      this.selectedEnrollId = val;
      this.fastNewMode = "edit";
    },
    updateWantTime(val) {
      this.wantTime = val;
    },
    updateData() {
      this.$emit("update", this.date);
    },
    closeEditEnrollPopup() {
      this.editEnrollPopup.show = false;
    },
    getDiffTime(time_from, time_to) {
      let result = formatter.minuteSplitHumanHourMinute(time_to - time_from);
      return result;
    },
    minuteToTime(minutes) {
      return formatter.minuteToTime(minutes);
    },
    getStaffName(staffId){
      let result = '-';
      for(let key in this.staff){
        if(+staffId === +this.staff[key].id){
          result = this.staff[key].name;
        }
      }
      if(result.length > 25){
        return result.slice(0, 25) +'...';
      }else{
        return result.slice(0, 25);
      }
    },
    datePhpToRus(val){
      return formatter.phpDateToRus(val);
    },
    prevWeek() {
      this.nowDate.setDate(this.nowDate.getDate() - 7);
      this.renderWeek();
    },
    nextWeek() {
      this.nowDate.setDate(this.nowDate.getDate() + 7);
      this.renderWeek();
    }
  },
  created() {

  }
};
</script>

<style scoped lang="less">
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
  }
  100% {
    box-shadow: 0px 0px 24px 0px rgba(65, 162, 252, 1);
  }
}
.j-week--labels-container {
  //margin-bottom: 30px;
  box-sizing: border-box;

  .j-week--labels-overflow {
    overflow: auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    flex-direction: row;
    max-height: 70vh;
    direction: rtl;

    .day {
      text-align: center;
      min-width: 130px;
      margin-right: 5px;

      .date{
        background-color: #f0f4f9;
        font-size: 13px;
        //font-weight: 700;
        padding: 8px 5px;
        box-sizing: border-box;
        margin-bottom: 5px;
        border-bottom: 2px solid transparent;
        direction: ltr;
        //box-shadow: 3px 3px 6px 0px rgba(0, 0, 0, 0.15);

        &.today{
          border-bottom: 2px solid #F97979;
        }
      }

      .no-schedule{
        font-size: 12px;
        color: gray;
      }
      .staffs{
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        flex-direction: row;
        padding-bottom: 20px;
        direction: ltr;

        .staff{
          width: 150px;
          margin-right: 3px;
          margin-left: 3px;

          .name{
            font-weight: 700;
            text-overflow: ellipsis;
            overflow: hidden;
            height: 55px;
            font-size: 13px;
            padding: 6px;
            box-sizing: border-box;
            background-color: #f5f7fa;
            box-shadow: 3px 3px 6px 0px rgba(0, 0, 0, 0.15);
          }
          .error{
            border: 1px solid gray;
            padding: 4px;
            font-size: 12px;
          }
          .schedule{
            margin-top: 10px;
            font-size: 12px;
            .schedule-item{
              margin-top: 5px;
              .item-free{
                padding: 7px 5px;
                border-radius: 10px;
                background-color: #f0f4f9;

                .time-window{
                  font-size: 11px;
                }

                &.progress {
                  box-shadow: 0 0 0 rgba(204, 169, 44, 0.4);
                  animation: pulse 1s infinite;
                }

                .action{
                  margin-top: 4px;

                  .new-enroll{
                    color: #333;
                    font-size: 11px;
                  }
                }
              }
              .item-break{
                margin: 10px 0;
                color: #4F4F4F;
                text-decoration: underline;
              }
              .item-enroll{
                padding: 7px 5px;
                border-radius: 10px;

                .time-window{
                  font-size: 11px;
                }

                &.status-canceled{
                  color: #fff;
                }

                &.progress {
                  box-shadow: 0 0 0 rgba(204, 169, 44, 0.4);
                  animation: pulse 1s infinite;
                }

              }
            }
          }
        }
      }
    }
  }
}
</style>
